import React from "react";
import { motion } from "framer-motion";

const OverlayCountdown = ({ show, countdown }) => {
  if (!show) return null;

  const progress = (countdown / 5) * 100; // Assuming max delay is 5s; adjust dynamically if needed

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "fixed",
        top: 0, left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.75)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "#fff"
      }}
    >
      <div
        style={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          border: "8px solid #FFC107",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "2.5rem",
          fontWeight: "bold",
          background: "#1e1e1e",
          boxShadow: "0 0 30px #FFC107",
          position: "relative"
        }}
      >
        {countdown}s
        <div
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            background: `conic-gradient(#3498db ${progress}%, #444 0%)`,
            opacity: 0.2,
            zIndex: -1,
          }}
        ></div>
      </div>
      <p style={{ marginTop: 20, fontSize: "1.2rem", fontWeight: 500 }}>Please wait while we place your bet...</p>
    </motion.div>
  );
};

export default OverlayCountdown;
